import type { ViolationPageModel } from '@shared/common/validation/domain/model/validation-error-page.model';
import { AbstractCockpitError } from '@shared/common/error/domain/error/abstract-cockpit.error';

export class ConstraintValidationError extends AbstractCockpitError {
  public constructor(
    message: string,
    public readonly violations: ViolationPageModel[],
    code = 'VALIDATION_ERROR',
  ) {
    super(message, code);
  }
}
